/**
 * The reader (felini, volpe, with any staging suffix) and Fenice (localhost,
 * 127.0.0.1, the Android asset host) serve the book from these hosts, so a
 * link to them is navigation inside the content, not a link that leaves it.
 * localhost and 127.0.0.1 are deprecated in Fenice 1.26.7 and higher.
 */
function isReaderHost(hostname) {
    return (
        /^(felini|volpe)([.-]|$)/.test(hostname) ||
        hostname === 'localhost' ||
        hostname.endsWith('.localhost') ||
        hostname === '127.0.0.1' ||
        hostname === 'appassets.androidplatform.net'
    );
}

/**
 * Tells whether an href leaves the publication. A relative href, a file:// URL
 * and the hosts that serve the reader and the book stay inside it.
 *
 * @param {string | null | undefined} urlString - Any href, absolute or relative.
 * @returns {boolean} True when the href points outside the reader and its hosts.
 */
function isExternalUrl(urlString) {
    // A reading-order href such as "OEBPS/ch1.xhtml" is not a URL at all.
    let url;
    try {
        url = new URL(urlString);
    } catch {
        return false;
    }
    if (url.protocol === 'file:') {
        return false;
    }
    return !isReaderHost(url.hostname);
}

function getAnchorFromEvent(event) {
    const tag = 'A';
    let node = event.target;
    let levelsChecked = 0;

    /*
     * We are only checking 3 levels (target, parent, and grandparent)
     * to ensure we properly find the anchor (<a>) element.
     */
    while (node && levelsChecked < 3) {
        if (node.tagName?.toUpperCase() === tag) {
            return node;
        }

        node = node.parentNode;
        levelsChecked++;
    }

    return null;
}

export { getAnchorFromEvent, isExternalUrl };
